import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonComponent } from './person.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@presentation/view/shared/shared.module';
import { AppMaterialModule } from 'src/app/app-material.module';
import { NgxMaskModule } from 'ngx-mask';
import { TelefoneIntlComponent } from '@presentation/view/shared/components/telefone-intl/telefone-intl.component';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    AppMaterialModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskModule.forRoot(),
  ]
})
export class PersonModule { }
